export const REFUND_PATH = {
	BASE: 'refund',
	PASSENGERS: 'passengers',
	REASONS: 'reasons',
	DOCUMENTS: 'documents',
	CREATE: 'create',
	REQUEST: 'request'
} as const;

const REFUND_BASE = `/${REFUND_PATH.BASE}` as const;

export const REFUND_ROUTES = {
	BASE: REFUND_BASE,
	PASSENGERS: `${REFUND_BASE}/${REFUND_PATH.PASSENGERS}`,
	REASONS: `${REFUND_BASE}/${REFUND_PATH.REASONS}`,
	DOCUMENTS: `${REFUND_BASE}/${REFUND_PATH.DOCUMENTS}`,
	CREATE: `${REFUND_BASE}/${REFUND_PATH.CREATE}`,
	REQUEST: `${REFUND_BASE}/${REFUND_PATH.REQUEST}`
};

export const REFUND_ROUTES_MAP = new Map([
	[REFUND_ROUTES.PASSENGERS, { next: REFUND_ROUTES.REASONS, prev: null }],
	[REFUND_ROUTES.REASONS, { next: REFUND_ROUTES.DOCUMENTS, prev: REFUND_ROUTES.PASSENGERS }],
	[REFUND_ROUTES.DOCUMENTS, { next: REFUND_ROUTES.CREATE, prev: REFUND_ROUTES.REASONS }],
	[REFUND_ROUTES.CREATE, { next: REFUND_ROUTES.REQUEST, prev: REFUND_ROUTES.DOCUMENTS }],
	[REFUND_ROUTES.REQUEST, { next: null, prev: REFUND_ROUTES.CREATE }]
]);
